Vue.component('bundleDetail', {
    data() {
        return {
            configurator3dopen: false
        };
    },
    props: ['colijnurl'],
    mounted() {

        // Load Configurator with deeplink
        this.checkHash();

        /*
        // Load Configurator when user uses browser back
        window.onpopstate = (e) => {
            if (e.state !== null && e.state.config3d != null) {
                this.toggleconfigurator3d(true);
            }
        };
        */
  },
  watch: {
  },
  methods: {

      toggleconfigurator3d(byPopState) {

          app.justAddedToCart = false;

          var footer = document.getElementsByClassName('footer');

          var iframe = document.getElementById('iframeWebGL');

          if (iframe != null) {

              if (!this.configurator3dopen) {
                  window.scroll(0, 0);
              }
              this.configurator3dopen = !this.configurator3dopen;

              if (this.configurator3dopen) {
                  app.showStickyHeader(false);

                  if (footer != null && footer.length > 0) {
                      footer[0].style.display = "none";
                  }

                  var receipt = document.getElementById('roomplannerreceipt');
                  if (receipt != null) {

                      iframe.style.display = "block";

                      receipt.style.display = "none";

                      var backdetailsbutton = document.getElementById('backdetailsbutton');
                      if (backdetailsbutton != null) {
                          backdetailsbutton.style.display = "inline-block";
                      }

                      var receiptbackbutton = document.getElementById('receiptbackbutton');
                      if (receiptbackbutton != null) {
                          receiptbackbutton.style.display = "none";
                      }

                      var receiptbutton = document.getElementById('receiptbutton');
                      if (receiptbutton != null) {
                          receiptbutton.style.display = "none";
                      }
                  }

                  document.body.classList.add('configurator-open');
                  iframe.src = this.colijnurl;

                  app.influxDbEvent("Show3dConfigurator");
              } else {
                  app.showStickyHeader(true);

                  if (footer != null && footer.length > 0) {
                      footer[0].style.display = "block";
                  }

                  document.body.classList.remove('configurator-open');
              }
              /*
              if (!byPopState) {
                  if (this.configurator3dopen) {
                      window.history.pushState({ config3d: this.configurator3dopen }, 'deeplink', '#config3d');
                  } else {
                      window.history.pushState({ config3d: this.configurator3dopen },
                          document.title,
                          window.location.pathname);

                  }
              }*/
          }
      },

      checkHash() {

          if (window.location.hash !== null && window.location.hash.indexOf('config3d') > 0) {
              this.toggleconfigurator3d(false);
          }
      },

  },
});
